import Vue from 'vue'
import * as types from './mutation-types.js'

// Send a heartbeat 4 times a minute
const HEARTBEAT_INTERVAL = 15000

const mutations = {
  [types.SOCKET_ONOPEN] (state, event) {
    Vue.prototype.$socket = event.currentTarget
    state.socket.isConnected = true

    if (state.event) {
      const message = {
        type: state.event.type,
        subscribe: state.event.eventId
      }

      Vue.prototype.$socket.sendObj(message)
    }

    // NOTE: Clock skew should be fine here, if the socket drops this
    // interval will be reset.
    state.timer = setInterval(() => {
      Vue.prototype.$socket.sendObj({ type: 'heartbeat' })
    }, HEARTBEAT_INTERVAL)
  },
  [types.SOCKET_ONCLOSE] (state, event) {
    const { timer } = state

    state.socket.isConnected = false

    if (timer) {
      clearInterval(timer)

      state.timer = null
    }
  },
  [types.SOCKET_ONERROR] (state, event) {
    // console.error(state, event)
  },
  // default handler called for all methods
  [types.SOCKET_ONMESSAGE] (state, message) {
    state.socket.message = message
  },
  // mutations for reconnect methods
  [types.SOCKET_RECONNECT] (state, count) {
    // console.info(state, count)
  },
  [types.SOCKET_RECONNECT_ERROR] (state) {
    state.socket.reconnectError = true
  },
  [types.SET_EVENT] (state, event) {
    state.event = event
  },
  [types.CLEAR_EVENT] (state) {
    state.event = null
  }
}

export default mutations
